import { Component, Input } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'skeletor-table',
  standalone: true,
  imports: [CommonModule, NgFor, SkeletonModule],
  templateUrl: './table.template.component.html',
  styleUrls: ['./table.template.component.scss']
})
export class SkeletorTableTemplateComponent {
  @Input() items: number = 5;
  get rows() { return Array.from({ length: this.items }); }
}

